module.exports = __webpack_public_path__ + "front/img/edm-banner-xianxia-bj.fbfff648.png";